import {
  CameraResultType,
  CameraDirection,
  CameraSource,
  Camera,
} from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { Injectable } from '@angular/core';
import { MediaFileService } from './media-file-service';
import { ActionSheet, LoadingController } from 'ionic-angular';
import { MediaCapture } from '@ionic-native/media-capture';
import { FilePath } from '@ionic-native/file-path';
import { VideoEditor } from '@ionic-native/video-editor';
// multi choosers testing
import { Chooser } from '@ionic-native/chooser/ngx';
import { FilePicker } from '@capawesome/capacitor-file-picker';

import * as uuid from 'uuid';
import debug from 'debug';
import * as _ from 'lodash';
import { Directory, Filesystem, WriteFileResult } from '@capacitor/filesystem';
import { ConfigProvider } from '../config/config';
import { ToolsProvider } from '../tools/tools';

type ActionSheetType = 'photo' | 'photos' | 'video' | 'all';
export enum ActionSheetButtonType {
  TAKE_PHOTO = 'Take Photo',
  TAKE_VIDEO = 'Take Video',
  CHOOSE_PHOTO = 'Choose Existing Photo',
  CHOOSE_PHOTOS = 'Choose Existing Photos',
  CHOOSE_VIDEO = 'Choose Existing Video',
  CHOOSE_PHOTOS_VIDEOS = 'Choose Existing Photos/Videos',
}

export const icons = {
  camera: `<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.125 1C10.2188 1 10.3125 1.09375 10.3438 1.1875L11.0312 3H14.5C14.75 3 15 3.25 15 3.5V12.5C15 12.7812 14.75 13 14.5 13H1.5C1.21875 13 1 12.7812 1 12.5V3.5C1 3.25 1.21875 3 1.5 3H4.9375L5.5625 1.34375C5.625 1.15625 5.8125 1 6.03125 1H10.125ZM10.125 0H6.03125C5.40625 0 4.84375 0.40625 4.625 1L4.25 2H1.5C0.65625 2 0 2.6875 0 3.5V12.5C0 13.3438 0.65625 14 1.5 14H14.5C15.3125 14 16 13.3438 16 12.5V3.5C16 2.6875 15.3125 2 14.5 2H11.75L11.2812 0.8125C11.0938 0.34375 10.6562 0 10.125 0ZM8 11.75C10.0625 11.75 11.75 10.0938 11.75 8C11.75 5.9375 10.0625 4.25 8 4.25C5.90625 4.25 4.25 5.9375 4.25 8C4.25 10.0938 5.90625 11.75 8 11.75ZM8 5.25C9.5 5.25 10.75 6.5 10.75 8C10.75 9.53125 9.5 10.75 8 10.75C6.46875 10.75 5.25 9.53125 5.25 8C5.25 6.5 6.46875 5.25 8 5.25Z" fill="#262626"/></svg>`,
  video: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V176z"/></svg>`,
  library: `<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 0H3.5C2.65625 0 2 0.6875 2 1.5V2H1.5C0.65625 2 0 2.6875 0 3.5V12.5C0 13.3438 0.65625 14 1.5 14H14.5C15.3125 14 16 13.3438 16 12.5V12H16.5C17.3125 12 18 11.3438 18 10.5V1.5C18 0.6875 17.3125 0 16.5 0ZM15 12.5C15 12.7812 14.75 13 14.5 13H1.5C1.21875 13 1 12.7812 1 12.5V3.5C1 3.25 1.21875 3 1.5 3H2V10.5C2 11.3438 2.65625 12 3.5 12H15V12.5ZM17 10.5C17 10.7812 16.75 11 16.5 11H3.5C3.21875 11 3 10.7812 3 10.5V1.5C3 1.25 3.21875 1 3.5 1H16.5C16.75 1 17 1.25 17 1.5V10.5ZM5.5 5.25C6.4375 5.25 7.25 4.46875 7.25 3.5C7.25 2.5625 6.4375 1.75 5.5 1.75C4.53125 1.75 3.75 2.5625 3.75 3.5C3.75 4.46875 4.53125 5.25 5.5 5.25ZM5.5 2.75C5.90625 2.75 6.25 3.09375 6.25 3.5C6.25 3.9375 5.90625 4.25 5.5 4.25C5.0625 4.25 4.75 3.9375 4.75 3.5C4.75 3.09375 5.0625 2.75 5.5 2.75ZM13 3.5C12.7188 3.1875 12.25 3.1875 11.9688 3.5L9 6.46875L8 5.5C7.71875 5.1875 7.25 5.1875 6.96875 5.5L4.21875 8.25C4.09375 8.34375 4 8.59375 4 8.75V9.625C4 9.84375 4.15625 10 4.375 10H15.625C15.8125 10 16 9.84375 16 9.625V6.75C16 6.5625 15.9062 6.375 15.75 6.25L13 3.5ZM15 9H5V8.875L7.5 6.375L9 7.875L12.5 4.375L15 6.875V9Z" fill="#262626"/></svg>`,
  photoLibrary: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M160 64H512c17.7 0 32 14.3 32 32V201.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V304v16c0 35.3 28.7 64 64 64h80 0H512c35.3 0 64-28.7 64-64V240 240 96zM464 166.6l80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/></svg>`,
  videoLibrary: `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M576 32H256c-17.7 0-32 14.3-32 32V233.4L297.4 160c12.5-12.5 32.8-12.5 45.3 0L384 201.4 489.4 96c12.5-12.5 32.8-12.5 45.3 0L608 169.4V64c0-17.7-14.3-32-32-32zm64 176c0 0 0 0 0 .1v80c0 35.3-28.7 64-64 64H272c0 0 0 0 0 0H256c-35.3 0-64-28.7-64-64V272s0 0 0 0V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V208zm-32 6.7l-96-96L395.3 235.3 310.6 320H576c17.7 0 32-14.3 32-32V214.6zM265.4 320l96-96L320 182.6l-96 96V288c0 17.7 14.3 32 32 32h9.4zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 160h32v32H128v80V400v80H384V384h32v96h32c17.7 0 32-14.3 32-32V384h32v64c0 35.3-28.7 64-64 64H416 400 384 128 112 96 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H96h16 16zM32 256H96V192H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32H96V416H32zm64-32V288H32v96H96z"/></svg>`,
  gif: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="4.5" y="4.5" width="15" height="15" rx="3.86364" fill="white"/>
  <path d="M9.01636 14.3455C8.61394 14.3455 8.25758 14.28 7.94727 14.1491C7.63697 14.0182 7.37273 13.8364 7.15455 13.6036C6.94121 13.3661 6.77879 13.0873 6.66727 12.7673C6.55576 12.4424 6.5 12.0909 6.5 11.7127V11.6545C6.5 11.2764 6.56061 10.9248 6.68182 10.6C6.80303 10.2752 6.97515 9.99394 7.19818 9.75636C7.42121 9.51879 7.68545 9.33455 7.99091 9.20364C8.30121 9.06788 8.64303 9 9.01636 9C9.27333 9 9.52061 9.03152 9.75818 9.09455C9.99576 9.15758 10.2091 9.25697 10.3982 9.39273C10.5921 9.52364 10.7521 9.69333 10.8782 9.90182C11.0091 10.1103 11.0939 10.36 11.1327 10.6509H10.5C10.4273 10.2388 10.2576 9.94545 9.99091 9.77091C9.72909 9.59152 9.40909 9.50182 9.03091 9.50182C8.7303 9.50182 8.46364 9.55515 8.23091 9.66182C7.99818 9.76364 7.80182 9.90909 7.64182 10.0982C7.48182 10.2873 7.36061 10.5127 7.27818 10.7745C7.19576 11.0364 7.15455 11.3273 7.15455 11.6473V11.7055C7.15455 12.0255 7.19333 12.3188 7.27091 12.5855C7.35333 12.8473 7.47212 13.0703 7.62727 13.2545C7.78242 13.4388 7.97636 13.5818 8.20909 13.6836C8.44182 13.7855 8.71091 13.8364 9.01636 13.8364C9.29758 13.8364 9.54 13.7927 9.74364 13.7055C9.94727 13.6182 10.1145 13.5018 10.2455 13.3564C10.3812 13.2061 10.4806 13.0315 10.5436 12.8327C10.6115 12.6291 10.6479 12.4109 10.6527 12.1782H9.13273V11.6545H11.2709V12.04C11.2709 12.4182 11.2152 12.7503 11.1036 13.0364C10.997 13.3224 10.8442 13.5624 10.6455 13.7564C10.4467 13.9503 10.2091 14.0982 9.93273 14.2C9.65636 14.297 9.35091 14.3455 9.01636 14.3455Z" fill="#262626"/>
  <path d="M12.3662 9.08H12.9989V14.28H12.3662V9.08Z" fill="#262626"/>
  <path d="M14.3469 9.08H17.3869V9.59636H14.9796V11.4364H16.856V11.9527H14.9796V14.28H14.3469V9.08Z" fill="#262626"/>
  <path d="M9.01636 14.3455C8.61394 14.3455 8.25758 14.28 7.94727 14.1491C7.63697 14.0182 7.37273 13.8364 7.15455 13.6036C6.94121 13.3661 6.77879 13.0873 6.66727 12.7673C6.55576 12.4424 6.5 12.0909 6.5 11.7127V11.6545C6.5 11.2764 6.56061 10.9248 6.68182 10.6C6.80303 10.2752 6.97515 9.99394 7.19818 9.75636C7.42121 9.51879 7.68545 9.33455 7.99091 9.20364C8.30121 9.06788 8.64303 9 9.01636 9C9.27333 9 9.52061 9.03152 9.75818 9.09455C9.99576 9.15758 10.2091 9.25697 10.3982 9.39273C10.5921 9.52364 10.7521 9.69333 10.8782 9.90182C11.0091 10.1103 11.0939 10.36 11.1327 10.6509H10.5C10.4273 10.2388 10.2576 9.94545 9.99091 9.77091C9.72909 9.59152 9.40909 9.50182 9.03091 9.50182C8.7303 9.50182 8.46364 9.55515 8.23091 9.66182C7.99818 9.76364 7.80182 9.90909 7.64182 10.0982C7.48182 10.2873 7.36061 10.5127 7.27818 10.7745C7.19576 11.0364 7.15455 11.3273 7.15455 11.6473V11.7055C7.15455 12.0255 7.19333 12.3188 7.27091 12.5855C7.35333 12.8473 7.47212 13.0703 7.62727 13.2545C7.78242 13.4388 7.97636 13.5818 8.20909 13.6836C8.44182 13.7855 8.71091 13.8364 9.01636 13.8364C9.29758 13.8364 9.54 13.7927 9.74364 13.7055C9.94727 13.6182 10.1145 13.5018 10.2455 13.3564C10.3812 13.2061 10.4806 13.0315 10.5436 12.8327C10.6115 12.6291 10.6479 12.4109 10.6527 12.1782H9.13273V11.6545H11.2709V12.04C11.2709 12.4182 11.2152 12.7503 11.1036 13.0364C10.997 13.3224 10.8442 13.5624 10.6455 13.7564C10.4467 13.9503 10.2091 14.0982 9.93273 14.2C9.65636 14.297 9.35091 14.3455 9.01636 14.3455Z" stroke="#262626" stroke-width="0.2"/>
  <path d="M12.3662 9.08H12.9989V14.28H12.3662V9.08Z" stroke="#262626" stroke-width="0.2"/>
  <path d="M14.3469 9.08H17.3869V9.59636H14.9796V11.4364H16.856V11.9527H14.9796V14.28H14.3469V9.08Z" stroke="#262626" stroke-width="0.2"/>
  <rect x="4.5" y="4.5" width="15" height="15" rx="3.86364" stroke="#262626"/>
  </svg>`,
};

declare var CmKit: any;

@Injectable()
export class MediaSelectorProvider {
  log = debug('app:MediaSelector.Provider');

  constructor(
    public mediaFileService: MediaFileService,
    public loadingCtrl: LoadingController,
    public filePath: FilePath,
    private mediaCapture: MediaCapture,
    private videoEditor: VideoEditor,
    private chooser: Chooser,
    private configs: ConfigProvider,
    public tools: ToolsProvider
  ) {
    this.log('MediaSelectorProvider Provider');
    window['MediaSelectorProvider'] = this;
  }

  icons = icons;

  async getImage(
    cameraSource: CameraSource = CameraSource.Photos,
    opts?: { limit?: number }
  ) {
    try {
      let images: { imageUrl: any; format: any }[] = [];
      if (cameraSource === CameraSource.Camera) {
        this.log('getImage | getPhoto');
        const image = await Camera.getPhoto({
          quality: 90,
          resultType: CameraResultType.Uri,
          direction: CameraDirection.Rear,
          allowEditing: true,
          correctOrientation: true,
          // preserveAspectRatio: true, // removed in cap4
          source: cameraSource,
          saveToGallery: true,
          width: 500,
        });
        this.log('getImage | image', image);
        images.push({
          imageUrl: image.path || image.webPath,
          format: image.format,
        });
      } else if (cameraSource === CameraSource.Photos) {
        this.log('getImage | pickImages');
        let selected = await Camera.pickImages({ limit: 5, quality: 90 }).catch(
          (e) => {
            this.log('getImage | error', e);
          }
        );
        this.log('getImage | selected');
        _.each(_.get(selected, 'photos'), (image) => {
          images.push({
            imageUrl: image.path || image.webPath,
            format: image.format,
          });
        });
      }

      this.log('getImage | images', images);

      let uploads = [];
      let limit = _.get(opts, 'limit');
      if (limit && _.size(images) > limit) {
        alert(`Please select only ${limit} file${limit > 1 ? 's' : ''}.`);
        return Promise.reject(
          `Please select only ${limit} file${limit > 1 ? 's' : ''}.`
        );
      } else if (!_.size(images)) {
        return Promise.reject('Error: No images found');
      }

      _.each(images, async (image) => {
        if (image.imageUrl) {
          this.log('getImage | would upload');
          uploads.push(
            this.mediaFileService.uploadAWSDocument(
              image.imageUrl,
              image.format || 'jpeg'
            )
          );
        }
      });

      const result = await Promise.all(uploads);
      return result;
    } catch (e) {
      this.log('error: ', e);
      throw new Error(e);
    }
  }

  async getVideo(cameraSource: CameraSource = CameraSource.Photos) {
    let video = { url: '', format: '' };
    let newFile: WriteFileResult | { uri: '' } = { uri: '' };
    if (cameraSource === CameraSource.Camera) {
      const videoCapture = await this.mediaCapture.captureVideo({
        duration: 90,
        quality: 1,
      });
      this.log('getVideo | videoCapture', videoCapture);

      if (Capacitor.getPlatform() === 'ios') {
        const transcoded = await this.videoEditor.transcodeVideo({
          fileUri: _.get(videoCapture, '0.fullPath'),
          outputFileName: uuid.v4() + '.mp4',
          outputFileType: this.videoEditor.OutputFileType.MPEG4,
          optimizeForNetworkUse: this.videoEditor.OptimizeForNetworkUse.YES,
          saveToLibrary: true,
        });
        this.log('getVideo | transcoded', transcoded);
        video.url = transcoded;
      } else {
        video.url = _.get(videoCapture, '0.fullPath');
      }
      video.format = _.split(videoCapture[0].type, '/')[1] || 'mp4';
      this.log('getVideo | video final', video);
    } else if (cameraSource === CameraSource.Photos) {
      var permissions = window['cordova'].plugins.permissions;

      permissions.requestPermission(
        permissions.READ_MEDIA_VIDEO,
        (res) => {
          console.log('callback success', res);
        },
        (e) => {
          console.log('callback error', e);
        }
      );

      const result = await FilePicker.pickVideos({
        multiple: false,
      });
      this.log('getVideo | filePicker result', result);

      const localFile = _.head(result.files);

      this.log('getVideo | localFile', localFile);

      video.url = localFile.path;
      video.format = 'mp4';
    }

    this.log('getVideo | video final', video);
    if (!video.url) {
      return;
    }

    const file = await this.mediaFileService.uploadAWSDocument(
      video.url,
      video.format || 'mp4'
    );

    this.log('getVideo | aws upload', file);

    return file;

    // removing video-poster entirely. now using + '#t=0.1' on video source tags
    // const videoPoster = await this.videoEditor
    //   .createThumbnail({
    //     fileUri: video.url,
    //     outputFileName: 'output-name.jpg',
    //     atTime: 0,
    //   })
    //   .catch((e) => {
    //     console.log('getVideo | video poster error');
    //   });

    // const videoPosterUpload = await this.mediaFileService.uploadAWSDocument(
    //   videoPoster || '',
    //   'jpg'
    // );

    // return _.merge(file, { poster: _.get(videoPosterUpload, 'url') || '' });
  }

  async showActionSheet(
    type: ActionSheetType = 'all',
    opts?: {
      additionalOption: { icon: string; text: string; handler: Function };
    }
  ) {
    let buttons = [];
    if (type === 'photos' || type === 'photo') {
      buttons = [
        {
          icon: icons.camera,
          text: ActionSheetButtonType.TAKE_PHOTO,
        },
        {
          icon: icons.photoLibrary,
          text:
            type === 'photos'
              ? ActionSheetButtonType.CHOOSE_PHOTOS
              : ActionSheetButtonType.CHOOSE_PHOTO,
        },
      ];
    } else if (type === 'video') {
      buttons = [
        {
          icon: icons.video,
          text: ActionSheetButtonType.TAKE_VIDEO,
        },
        {
          icon: icons.videoLibrary,
          text: ActionSheetButtonType.CHOOSE_VIDEO,
        },
      ];
    } else if (type === 'all') {
      buttons = [
        {
          icon: icons.camera,
          text: ActionSheetButtonType.TAKE_PHOTO,
        },
        {
          icon: icons.video,
          text: ActionSheetButtonType.TAKE_VIDEO,
        },
        {
          icon: icons.photoLibrary,
          text: ActionSheetButtonType.CHOOSE_PHOTO,
        },
        {
          icon: icons.videoLibrary,
          text: ActionSheetButtonType.CHOOSE_VIDEO,
        },
      ];
    }

    if (_.get(opts, 'additionalOption')) {
      buttons.push(opts.additionalOption);
    }

    return CmKit.ActionSheet({
      props: {
        buttons,
      },
    }).promise;
  }

  async getMediaByType(
    type: ActionSheetType = 'all',
    opts?: { additionalOption: any }
  ) {
    if (this.tools.isWeb) {
      return this.tools.showDownloadApp();
    }

    try {
      await Camera.checkPermissions();
      const fileSystem = await Filesystem.requestPermissions();
      this.log('permissions | fileSystem', fileSystem);
      const photos = await Camera.requestPermissions({
        permissions: ['photos'],
      });
      this.log('permissions | photos', photos);
      const camera = await Camera.requestPermissions({
        permissions: ['camera'],
      });
      this.log('permissions | camera', camera);
    } catch (e) {
      this.log('permissions failed');
    }

    const mediaType = await this.showActionSheet(type, opts);

    let loading = this.loadingCtrl.create({});
    loading.present();

    this.log('getMediaByType | mediaType', mediaType);
    let files = [];
    try {
      if (mediaType.text === ActionSheetButtonType.TAKE_PHOTO) {
        files = await this.getImage(CameraSource.Camera);
      } else if (mediaType.text === ActionSheetButtonType.TAKE_VIDEO) {
        files = await this.getVideo(CameraSource.Camera);
      } else if (mediaType.text === ActionSheetButtonType.CHOOSE_PHOTOS) {
        files = await this.getImage(CameraSource.Photos);
      } else if (mediaType.text === ActionSheetButtonType.CHOOSE_PHOTO) {
        files = await this.getImage(CameraSource.Photos, { limit: 1 });
      } else if (mediaType.text === ActionSheetButtonType.CHOOSE_VIDEO) {
        files = await this.getVideo(CameraSource.Photos);
      } else if (
        mediaType.text === ActionSheetButtonType.CHOOSE_PHOTOS_VIDEOS
      ) {
        files = await this.getImage(CameraSource.Photos);
      } else if (_.get(mediaType, 'handler')) {
        this.log('getMediaByType | external function', mediaType.handler);
        loading.dismiss();
        return mediaType.handler;
      }

      this.log('getMediaByType | files', files);
      loading.dismiss();
      return files;
    } catch (e) {
      loading.dismiss();
    }
  }

  async quickLoad() {
    let loading = this.loadingCtrl.create({});
    loading.present();

    setTimeout(() => {
      loading.dismiss();
    }, 2000);
  }

  async getMetadata(url) {
    return this.mediaFileService.getMetadata(url);
  }

  async getFileFromInput(mimeType = '*'): Promise<File> {
    const input = document.createElement('input');
    input.type = 'file';
    input.hidden = true;
    input.accept = mimeType;
    input.id = `${mimeType}Upload`;
    input.name = `${mimeType}Upload`;

    input.click();

    return new Promise((resolve, reject) => {
      input.addEventListener('change', (e) => {
        console.log('getFileFromInput | change', _.get(e.target, 'files'));
        resolve(_.head(_.get(e.target, 'files')));
      });
    });
  }

  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
}



// WEBPACK FOOTER //
// ./src/providers/image-selector/media-selector.ts